export const dictionary = {
  PAGE_TITLE: {
    ES: "Configuración de tu tienda",
    EN: "Store settings",
  },
  VISIT_STORE: {
    ES: "Ver tienda",
    EN: "Go to store",
  },
  NAVBAR: {
    ES: "Navegación",
    EN: "Navbar",
  },
  DEFAULT_COLORS: {
    ES: "Colores predeterminados",
    EN: "Default colors",
  },
  CUSTOMIZE_COLOR: {
    ES: "Personalizar color",
    EN: "Customize color",
  },
  BACKGROUND: {
    ES: "Color del fondo ",
    EN: "Background color",
  },
  TEXT_COLOR: {
    ES: "Color del texto",
    EN: "Text color",
  },
  BANNER_INFO: {
    ES: "Información",
    EN: "Banner info",
  },
  MENU_LAYOUT: {
    ES: "Diseño del menu",
    EN: "Menu design"
  },
  CARD: {
    ES: "Tarjeta",
    EN: "Card"
  },
  LIST: {
    ES: "Lista",
    EN: "List"
  },
  LIST_WITH_IMAGE: {
    ES: "Lista con imagen",
    EN: "List with images"
  },
  ACCORDION: {
    ES: "Acordeón",
    EN: "Accordion"
  }
} as const;
